/* eslint-disable jsx-a11y/no-onchange */
import React, { Component } from 'react'
import { connect } from 'react-redux'

import 'react-dates/initialize'
import { SingleDatePicker } from 'react-dates'

import 'react-dates/lib/css/_datepicker.css'

import { postAction } from '../../../api/api'

import {
  pageUpdateName,
  pageUpdatePixel,
  pageUpdateGA,
  pageUpdateCSS,
  pageUpdateJS,
  pageAddEmployee,
  pageDeleteEmployee,
  pageSetTemporaryStart,
  pageSetTemporaryEnd,
  pageToggleAutoAccept,
  pageToggleOneMoment,
  pageSetPreferredLanguage,
  changeAction,
  pageUpdateParticipants,
  setRequiredEmployee,
  pageToggleSequential,
  pageSetBuffer,
  pageSetFastestPossible,
  deleteCompanyPage,
  saveCompanies,
  setActivePage,
  setActiveTab,
} from '../../../store/pages-management/actions'

import './../Tabs/Editor/Editor.scss'
import './Preferences.scss'
import { PagesManagementTab } from '../../../store/pages-management/types'

const CheckBox = (props) => {
  return (
    <div
      className={props.selected ? 'checkbox selected' : 'checkbox'}
      onClick={() => {
        props.onToggle()
      }}
      role="presentation"
    >
      <div className="dot" />
    </div>
  )
}

class Preferences extends Component {
  constructor(props) {
    super(props)

    this.state = {
      addpeople: '',
      addpeopleerror: '',
      addpage: '',
      addpageerror: '',
      addpeopletopage: '',
      addpeopletopageerror: '',
      uploadingLogo: false,
      company: '',
      showPopup: false,
      start_focused: false,
      end_focused: false,
      selectedIntegration: 0,
    }
  }

  getIdForEmployee(employee) {
    employee = this.props.company.employees.find(
      (x) =>
        x.first_name + ' ' + x.last_name === employee || x.email === employee,
    )

    if (employee) {
      return employee.id
    } else {
      return 0
    }
  }

  addEmployeeToPage(employee) {
    const { strings } = this.props

    const id = this.getIdForEmployee(employee)
    if (id !== 0) {
      this.props.pageAddEmployee(id)
      this.setState({
        addpeopletopageerror: '',
        addpeopletopage: '',
      })
    } else {
      this.setState({
        addpeopletopageerror: strings.not_an_employee,
      })
    }
  }

  createTempCookie(name, value, minutes) {
    let expires = ''
    if (minutes) {
      const date = new Date()
      date.setTime(date.getTime() + minutes * 1000)
      expires = '; expires=' + date.toUTCString()
    }
    document.cookie = name + '=' + value + expires + '; path=/'
  }

  deleteFromPage(employee_id) {
    const { strings } = this.props
    if (this.props.page.employees.length > 1) {
      this.props.pageDeleteEmployee(employee_id)
    } else {
      this.setState({
        addpeopletopageerror: strings.one_linked,
      })
    }
  }

  async updateAction(action, val, selected) {
    const action_info = {
      action_id: action.action_id,
      local_action_id: action.local_action_id,
      value: val,
      selected: selected,
      page_id: this.props.page.id,
    }

    const response = await postAction(action_info)

    if ('local_action_id' in response) {
      this.props.changeAction(
        this.state.selectedIntegration,
        action.action_id,
        response.local_action_id,
        val,
        selected,
      )
    } else if (response.success) {
      this.props.changeAction(
        this.state.selectedIntegration,
        action.action_id,
        action.local_action_id,
        val,
        selected,
      )
    }
  }

  renderAutoAccept() {
    const { strings } = this.props

    return (
      <div className="part head autoaccept">
        <h3 className="part_header">{strings.autoaccept}</h3>
        <div>
          <span>{strings.autoaccept_explanation}</span>
          <div className="checkbox_section">
            <CheckBox
              selected={this.props.page.auto_accept}
              onToggle={() => {
                this.props.toggleAutoAccept()
              }}
            />
          </div>
        </div>
      </div>
    )
  }

  renderBuffer() {
    const { strings } = this.props

    return (
      <div className="part head buffer">
        <h3 className="part_header">{strings.buffer}</h3>
        <div>
          <span>{strings.buffer_explanation}</span>
          <div>
            <select
              value={this.props.page.buffer}
              onChange={(e) => this.props.setBuffer(e.target.value)}
            >
              <option value={0}>{strings.no_buffer}</option>
              <option value={15}>15 mins</option>
              <option value={30}>30 mins</option>
              <option value={45}>45 mins</option>
              <option value={60}>60 mins</option>
              <option value={120}>2 hours</option>
              <option value={180}>3 hours</option>
              <option value={240}>4 hours</option>
              <option value={300}>5 hours</option>
              <option value={360}>6 hours</option>
              <option value={420}>7 hours</option>
              <option value={480}>8 hours</option>
            </select>
          </div>
        </div>
      </div>
    )
  }

  renderDeletePage() {
    const { page, strings, company } = this.props

    return (
      <div className="part head">
        <h3 className="part_header">{strings.delete_page}</h3>
        <div>
          <p>
            <button
              className="button is-danger"
              onClick={() => {
                this.props.deleteCompanyPage(page.id)
                this.props.setActivePage(company.pages[0].id)
                this.props.setActiveTab(PagesManagementTab.EDITOR)
              }}
            >
              {strings.delete_page}
            </button>
          </p>
        </div>
      </div>
    )
  }

  renderEmployees() {
    const { page, strings } = this.props

    return (
      <div className="part head employees">
        <h3 className="part_header">{strings.meeting_assignment}</h3>
        <div className="columns">
          <div className="column is-5">
            <h4>{strings.assignment}</h4>
            <div className="strategy">
              <div className="strategy_choice">
                <div
                  className={
                    page.participants === 0 ? 'radio selected' : 'radio'
                  }
                  onClick={() => {
                    this.props.pageUpdateParticipants(0)
                  }}
                  role="presentation"
                >
                  <div className="inner_radio" />
                </div>
                <span>
                  {strings.assign_to}
                  <b>{strings.all}</b>
                </span>
              </div>
              {page.employees.length > 1 && (
                <div className="strategy_choice">
                  <div
                    className={
                      page.participants > 1 ? 'radio selected' : 'radio'
                    }
                    onClick={() => {
                      this.props.pageUpdateParticipants(2)
                    }}
                    role="presentation"
                  >
                    <div className="inner_radio" />
                  </div>
                  <span>
                    {strings.assign_to}{' '}
                    <b>
                      <input
                        type="number"
                        data-lpignore="true"
                        min={1}
                        max={page.employees.length}
                        defaultValue={page.employees.length < 2 ? 1 : 2}
                        value={
                          page.participants === 0
                            ? page.employees.length
                            : page.participants
                        }
                        onChange={(e) => {
                          this.props.pageUpdateParticipants(e.target.value)
                        }}
                      />{' '}
                      {strings.persons}
                    </b>
                  </span>
                </div>
              )}
              {!(page.participants === 1 && page.auto_accept) && (
                <div className="strategy_choice">
                  <div
                    className={
                      page.participants === 1 && !page.auto_accept
                        ? 'radio selected'
                        : 'radio'
                    }
                    onClick={() => {
                      this.props.pageUpdateParticipants(1)
                    }}
                    role="presentation"
                  >
                    <div className="inner_radio" />
                  </div>
                  <span>
                    {strings.assign_to} <b>{strings.one_person}</b>
                  </span>
                </div>
              )}
              <div className="strategy_choice">
                <div
                  className={
                    page.participants === 1 && page.auto_accept
                      ? 'radio selected'
                      : 'radio'
                  }
                  onClick={() => {
                    this.props.pageUpdateParticipants(1)
                    if (!page.auto_accept) this.props.toggleAutoAccept()
                  }}
                  role="presentation"
                >
                  <div className="inner_radio" />
                </div>
                <span>
                  <b>{strings.round_robin}</b>
                </span>
              </div>
            </div>
          </div>
          <div className="column is-1 arrow">
            <i className="fa fa-arrow-right" />
          </div>
          <div className="column is-6">
            <h4>{strings.linked_to_page}</h4>
            {this.renderPageEmployees(page)}
            <div className="addEmployeeToPage">
              <input
                id="user_name"
                className="grey"
                data-lpignore="true"
                type="text"
                value={this.state.addpeopletopage}
                placeholder={strings.people_placeholder}
                onChange={(event) =>
                  this.setState({ addpeopletopage: event.target.value })
                }
                list="employees"
              />
              <button
                className="button is-primary add-employee"
                onClick={() => {
                  if (this.props.tier !== 'FREE') {
                    this.addEmployeeToPage(this.state.addpeopletopage)
                  } else {
                    this.props.openSubscribe()
                  }
                }}
              >
                {strings.people_add}
              </button>
            </div>
            <span className="error" style={{ marginTop: '20px' }}>
              {this.state.addpeopletopageerror}
            </span>
            <datalist id="employees">
              {this.props.company.employees
                .filter(function(empl1) {
                  return !page.employees.some(function(empl2) {
                    return empl1.id === empl2.id
                  })
                })
                .map((suggestion) => {
                  return (
                    <option
                      key={suggestion.id}
                      value={
                        suggestion.first_name !== '' &&
                        suggestion.last_name !== ''
                          ? suggestion.first_name + ' ' + suggestion.last_name
                          : suggestion.email
                      }
                    />
                  )
                }, this)}
            </datalist>
          </div>
        </div>
      </div>
    )
  }

  renderFastestPossible() {
    const { strings } = this.props

    return (
      <div className="part head fastest_possible">
        <h3 className="part_header">{strings.fastest_possible}</h3>
        <div>
          <span>{strings.fastest_possible_explanation}</span>
          <div>
            <select
              value={this.props.page.fastest_possible}
              onChange={(e) => this.props.setFastestPossible(e.target.value)}
            >
              <option value={0}>{strings.immediately}</option>
              <option value={15}>15 mins</option>
              <option value={30}>30 mins</option>
              <option value={60}>1h</option>
              <option value={120}>2h</option>
              <option value={240}>4h</option>
              <option value={480}>8h</option>
              <option value={960}>16h</option>
              <option value={1440}>24h</option>
            </select>
          </div>
        </div>
      </div>
    )
  }

  renderIntegrations() {
    const { strings } = this.props
    const integration = this.props.integrations.find((integration) => {
      return integration.id === this.state.selectedIntegration
    })

    let needsReconnect = false

    if (
      integration &&
      integration.actions &&
      integration.actions.onRequest &&
      integration.actions.onSchedule
    ) {
      const optionArrays = []
      optionArrays.push(
        ...integration.actions.onRequest.filter(
          (action) => action.type === 'OPTIONS',
        ),
      )
      optionArrays.push(
        ...integration.actions.onSchedule.filter(
          (action) => action.type === 'OPTIONS',
        ),
      )

      if (optionArrays.find((option) => option.option === null))
        needsReconnect = true
    }

    return (
      <div className="part integrations">
        <h3 className="part_header">{strings.integrations}</h3>
        <div>
          <p>{strings.integrations_explanation}</p>
          <div className="columns">
            <div className="list column is-4">
              <ul>
                {this.props.integrations.map((integration) => {
                  return (
                    <li
                      className={
                        this.state.selectedIntegration === integration.id
                          ? 'selected'
                          : ''
                      }
                      onClick={() => {
                        this.setState({
                          selectedIntegration: integration.id,
                        })
                      }}
                      key={integration.id}
                      role="presentation"
                    >
                      <img src={integration.logo} alt={integration.name} />
                      <span>{integration.name}</span>
                    </li>
                  )
                }, this)}
              </ul>
            </div>
            {this.state.selectedIntegration === 0 && (
              <div className="actions column is-8" />
            )}
            {this.state.selectedIntegration > 0 &&
              integration.connected &&
              !needsReconnect && (
              <div className="actions column is-8">
                <h4>{strings.actions}</h4>
                {integration.actions.onRequest.length > 0 && (
                  <b>{strings.on_request}</b>
                )}
                <ul>
                  {integration.actions.onRequest.map((action) => {
                    return (
                      <li key={action.action_id}>
                        <input
                          type="checkbox"
                          defaultChecked={action.selected}
                          onChange={(e) => {
                            this.updateAction(
                              action,
                              action.value,
                              e.target.checked,
                            )
                          }}
                        />
                        {action.label}
                        {action.type === 'OPTIONS' && (
                          <select
                            onChange={(e) => {
                              this.updateAction(
                                action,
                                e.target.value,
                                action.selected,
                              )
                            }}
                          >
                            {action.option.map((option) => {
                              return (
                                <option
                                  value={option.id}
                                  key={option.id}
                                  selected={action.value === option.id}
                                >
                                  {option.name}
                                </option>
                              )
                            })}
                          </select>
                        )}
                        {action.type === 'FIELD' && (
                          <select
                            onChange={(e) => {
                              this.updateAction(
                                action,
                                e.target.value,
                                action.selected,
                              )
                            }}
                          >
                            {this.props.page.fields.map((field) => {
                              return (
                                <option value={field.id} key={field.id}>
                                  {field.label}
                                </option>
                              )
                            })}
                          </select>
                        )}
                      </li>
                    )
                  })}
                </ul>
                {integration.actions.onSchedule.length > 0 && (
                  <b>{strings.on_schedule}</b>
                )}
                <ul>
                  {integration.actions.onSchedule.map((action) => {
                    return (
                      <li key={action.action_id}>
                        <input
                          type="checkbox"
                          defaultChecked={action.selected}
                          onChange={(e) => {
                            this.updateAction(
                              action,
                              action.value,
                              e.target.checked,
                            )
                          }}
                        />
                        {action.label}
                        {action.type === 'OPTIONS' && (
                          <select
                            onChange={(e) => {
                              this.updateAction(
                                action,
                                e.target.value,
                                action.selected,
                              )
                            }}
                            defaultValue={action.value}
                          >
                            {action.option.map((option) => {
                              return (
                                <option value={option.id} key={option.id}>
                                  {option.name}
                                </option>
                              )
                            })}
                          </select>
                        )}
                        {action.type === 'FIELD' && (
                          <select
                            onChange={(e) => {
                              this.updateAction(
                                action,
                                e.target.value,
                                action.selected,
                              )
                            }}
                          >
                            {this.props.page.fields.map((field) => {
                              return (
                                <option value={field.id} key={field.id}>
                                  {field.label}
                                </option>
                              )
                            })}
                          </select>
                        )}
                      </li>
                    )
                  })}
                </ul>
              </div>
            )}
            {((this.state.selectedIntegration > 0 && !integration.connected) ||
              needsReconnect) && (
              <div className="actions column is-8">
                <h4>{strings.link_to}</h4>
                {needsReconnect && (
                  <p style={{ color: 'indianred' }}>
                    <b>{integration.name + strings.needs_reconnect}</b>
                  </p>
                )}
                <div>
                  <button
                    className="button is-primary"
                    onClick={() => {
                      if (this.props.tier !== 'FREE') {
                        this.createTempCookie(
                          'page',
                          this.props.active_page,
                          1000,
                        )
                        window.location = decodeURI(integration.auth_url)
                      } else {
                        this.props.openSubscribe()
                      }
                    }}
                  >
                    {strings.connect_to + ' ' + integration.name}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }

  renderOneMoment() {
    const { strings } = this.props

    return (
      <div className="part head onemoment">
        <h3 className="part_header">{strings.one_moment}</h3>
        <div>
          <span>{strings.one_moment_explanation}</span>
          <div className="checkbox_section">
            <CheckBox
              selected={this.props.page.one_moment}
              onToggle={() => {
                this.props.toggleOneMoment()
              }}
            />
          </div>
        </div>
      </div>
    )
  }

  renderPageEmployee(employee, page) {
    const label =
      (employee.first_name === '' || employee.first_name === null) &&
      (employee.last_name === '' || employee.last_name === null)
        ? employee.email
        : employee.first_name + ' ' + employee.last_name

    const { strings } = this.props
    return (
      <div className="employee_card" key={employee.id}>
        <img src={employee.avatar} alt={label} />
        <span className="blue">{label}</span>
        {page.participants > 1 && (
          <div className="flags">
            <select
              onChange={(e) => {
                this.props.setRequiredEmployee(
                  employee.id,
                  e.target.value === 'true',
                )
              }}
              value={employee.required === true}
            >
              <option value={true}>{strings.must}</option>
              <option value={false}>{strings.might}</option>
            </select>
          </div>
        )}
        {page.employees.length > 1 && (
          <button
            className="underlined"
            onClick={() => {
              this.deleteFromPage(employee.id)
            }}
          >
            {strings.unlink}
          </button>
        )}
      </div>
    )
  }

  renderPageEmployees(page) {
    return (
      <div className="employee_cards">
        {page.employees.map((employee) =>
          this.renderPageEmployee(employee, page),
        )}
      </div>
    )
  }

  renderPageName() {
    const { page, strings } = this.props

    return (
      <div className="part head">
        <h3 className="part_header">{strings.page_name}</h3>
        <div>
          <input
            type="text"
            className="grey full-width"
            data-lpignore="true"
            value={page.name}
            onChange={(event) => {
              let valid_url_chars =
                ' ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789\\-\\._~:/?#[]@!$\'()*+,;='
              valid_url_chars = valid_url_chars.replace(
                /[.*+?^${}()|[\]\\]/g,
                '\\$&',
              )
              if (event.target.value.match('[^' + valid_url_chars + ']')) {
                alert(strings.cannot_contain)
              } else {
                this.props.pageUpdateName(event.target.value)
              }
            }}
            required
          />
        </div>
      </div>
    )
  }

  renderPreferredLanguage() {
    const { strings } = this.props

    return (
      <div className="part head preferred_language">
        <h3 className="part_header">{strings.preferred_language}</h3>
        <div>
          <span>{strings.preferred_language_explanation}</span>
          <div>
            <select
              value={this.props.page.preferred_language}
              onChange={(e) => this.props.setPreferredLanguage(e.target.value)}
            >
              <option value="eng">English</option>
              <option value="nl">Nederlands</option>
            </select>
          </div>
        </div>
      </div>
    )
  }

  renderSWAG() {
    const { page } = this.props

    return (
      <div className="part head">
        <h3 className="part_header">Custom</h3>
        <div>
          <div className="field">
            <label htmlFor="fbPixel">Facebook Pixel</label>
            <input
              name="fbPixel"
              type="text"
              className="grey full-width"
              value={page.pixel}
              onChange={(e) => {
                this.props.updatePixel(e.target.value)
              }}
            />
          </div>
          <div className="field">
            <label htmlFor="customCss">Custom CSS</label>
            <textarea
              name="customCss"
              className="grey full-width"
              value={page.css}
              rows={10}
              onChange={(e) => {
                this.props.updateCSS(e.target.value)
              }}
            />
          </div>
          <div className="field">
            <label htmlFor="customJs">Custom Javascript</label>
            <textarea
              name="customJs"
              className="grey full-width"
              value={page.js}
              rows={10}
              onChange={(e) => {
                this.props.updateJS(e.target.value)
              }}
            />
          </div>
        </div>
      </div>
    )
  }

  renderSequential() {
    const { strings } = this.props

    return (
      <div className="part head sequential">
        <h3 className="part_header">{strings.sequential}</h3>
        <div>
          <span>{strings.sequential}</span>
          <div className="checkbox_section">
            <CheckBox
              selected={this.props.page.seq}
              onToggle={() => {
                this.props.toggleSequential()
              }}
            />
          </div>
        </div>
      </div>
    )
  }

  renderTemporary() {
    const { strings } = this.props

    return (
      <div className="part head temporary">
        <h3 className="part_header">{strings.temporary_page}</h3>
        <div>
          <span>{strings.temporary_explanation}</span>
          {this.props.page.start && this.props.page.end && (
            <div className="columns">
              <div className="column is-4">
                <label>{strings.temporary_start}</label>
                <br />
                <SingleDatePicker
                  id="temporary_start"
                  date={this.props.page.start}
                  focused={this.state.start_focused}
                  onDateChange={(date) => {
                    this.props.setTemporaryStart(date.toDate())
                  }}
                  onFocusChange={({ focused }) => {
                    this.setState({ start_focused: focused })
                  }}
                  numberOfMonths={1}
                  displayFormat={'DD/MM/YYYY'}
                />
              </div>
              <div className="column is-4">
                <label>{strings.temporary_end}</label>
                <br />
                <SingleDatePicker
                  id="temporary_end"
                  date={this.props.page.end}
                  focused={this.state.end_focused}
                  onDateChange={(date) => {
                    this.props.setTemporaryEnd(date.toDate())
                  }}
                  onFocusChange={({ focused }) => {
                    this.setState({ end_focused: focused })
                  }}
                  numberOfMonths={1}
                  displayFormat={'DD/MM/YYYY'}
                />
              </div>
            </div>
          )}
          <div className="checkbox_section">
            <CheckBox
              selected={this.props.page.start && this.props.page.end}
              onToggle={() => {
                if (!(this.props.page.start && this.props.page.end)) {
                  const tomorrow = new Date()
                  tomorrow.setDate(tomorrow.getDate() + 1)

                  const dayaftertomorrow = new Date()
                  dayaftertomorrow.setDate(dayaftertomorrow.getDate() + 2)

                  this.props.setTemporaryStart(tomorrow)
                  this.props.setTemporaryEnd(dayaftertomorrow)
                } else {
                  this.props.setTemporaryStart(null)
                  this.props.setTemporaryEnd(null)
                }
              }}
            />
            <span className="blue">{strings.temporary}</span>
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="preferences">
        {this.props.company.admin && (
          <>
            {this.renderPageName()}
            <hr />
            {this.renderEmployees()}
            <hr />
            {this.renderTemporary()}
            <hr />
            {this.renderAutoAccept()}
            <hr />
            {this.renderOneMoment()}
            <hr />
            {this.renderPreferredLanguage()}
            <hr />
            {this.renderBuffer()}
            <hr />
            {this.renderFastestPossible()}
            <hr />
            {this.renderSequential()}
            <hr />
          </>
        )}
        {this.renderIntegrations()}
        <hr />
        {this.props.company.admin && (
          <>
            {this.renderSWAG()}
            <hr />
            {this.renderDeletePage()}
          </>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const page =
    state.pagesManagement.active_company && state.pagesManagement.active_page
      ? state.pagesManagement.companies
        .find(
          (company) => company.id === state.pagesManagement.active_company,
        )
        .pages.find((page) => page.id === state.pagesManagement.active_page)
      : null

  return {
    page: page,
    companies: state.pagesManagement.companies,
    company: state.pagesManagement.active_company
      ? state.pagesManagement.companies.find(
        (company) => company.id === state.pagesManagement.active_company,
      )
      : null,
    strings: state.languages.strings.pages.preferences,
    isFetching: state.pagesManagement.isFetching,
    integrations: page.integrations ? page.integrations : [],
    active_page: state.pagesManagement.active_page,
    tier: state.settings.tier,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    pageUpdateName: (name) => dispatch(pageUpdateName(name)),
    updatePixel: (pixel) => dispatch(pageUpdatePixel(pixel)),
    updateGA: (ga) => dispatch(pageUpdateGA(ga)),
    updateCSS: (css) => dispatch(pageUpdateCSS(css)),
    updateJS: (js) => dispatch(pageUpdateJS(js)),
    pageUpdateParticipants: (participants) =>
      dispatch(pageUpdateParticipants(participants)),
    pageAddEmployee: (employee) => dispatch(pageAddEmployee(employee)),
    setRequiredEmployee: (employee, required) =>
      dispatch(setRequiredEmployee(employee, required)),
    pageDeleteEmployee: (employee) => dispatch(pageDeleteEmployee(employee)),
    setTemporaryStart: (date) => dispatch(pageSetTemporaryStart(date)),
    setTemporaryEnd: (date) => dispatch(pageSetTemporaryEnd(date)),
    setActiveTab: (tab) => dispatch(setActiveTab(tab)),
    setActivePage: (tab) => dispatch(setActivePage(tab)),
    toggleAutoAccept: () => dispatch(pageToggleAutoAccept()),
    toggleOneMoment: () => dispatch(pageToggleOneMoment()),
    setPreferredLanguage: (language) =>
      dispatch(pageSetPreferredLanguage(language)),
    toggleSequential: () => dispatch(pageToggleSequential()),
    setBuffer: (buffer) => dispatch(pageSetBuffer(buffer)),
    setFastestPossible: (fastest_possible) =>
      dispatch(pageSetFastestPossible(fastest_possible)),
    deleteCompanyPage: (id) => dispatch(deleteCompanyPage(id)),
    saveCompanies: (companies) => dispatch(saveCompanies(companies)),
    changeAction: (
      integration_id,
      action_id,
      local_action_id,
      value,
      selected,
    ) =>
      dispatch(
        changeAction(
          integration_id,
          action_id,
          local_action_id,
          value,
          selected,
        ),
      ),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Preferences)
